import type { Booking } from "@/types";

const key = (userId: string) => `wn_bookings_${userId}`;

export const loadCachedBookings = (userId: string): Booking[] => {
  try {
    return JSON.parse(localStorage.getItem(key(userId)) || "[]");
  } catch {
    return [];
  }
};

export const saveCachedBookings = (userId: string, list: Booking[]) =>
  localStorage.setItem(key(userId), JSON.stringify(list));

export const addCachedBooking = (userId: string, b: Booking) =>
  saveCachedBookings(userId, [b, ...loadCachedBookings(userId).filter((x) => x.booking_id !== b.booking_id)]);
